import React from 'react';
import Shimmer from '../index';
import { getPreset, getShimmerOptions } from '../../Theme/selectors';
import withTheme from '../../Theme/withTheme';
var ShimmerAvatar = function ShimmerAvatar(_ref) {
  var className = _ref.className,
    propRadius = _ref.radius,
    propPreset = _ref.preset,
    propSize = _ref.size,
    style = _ref.style,
    uiTheme = _ref.uiTheme;
  var _getShimmerOptions = getShimmerOptions(uiTheme, 'avatar'),
    defaultPreset = _getShimmerOptions.preset,
    defaultRadius = _getShimmerOptions.radius,
    defaultSize = _getShimmerOptions.size;
  var presetName = propPreset || defaultPreset;
  var preset = getPreset(uiTheme, 'avatar', presetName);
  var presetSize = preset.size,
    presetRadius = preset.radius;
  var size = propSize || presetSize || defaultSize || 48;
  var radius = propRadius || presetRadius || defaultRadius || 0;
  return /*#__PURE__*/React.createElement(Shimmer, {
    className: className,
    width: size,
    height: size,
    radius: radius,
    style: style
  });
};
ShimmerAvatar.defaultProps = {
  className: null,
  radius: null,
  preset: null,
  size: null,
  style: {},
  uiTheme: null
};
ShimmerAvatar.displayName = 'ShimmerAvatar';
export default withTheme(ShimmerAvatar);